import _ from 'lodash';
import { DEFAULT_SCORE_LIMIT } from 'common/constants';
import { CardFacadeBase } from 'utils/facades/card-facade-base';
import { CardFlowEvent } from 'types/story';

class NavigationFacade extends CardFacadeBase {
	getNextEventByScore = ({ totalScore }): CardFlowEvent | null | undefined => {
		if (!this.data) {
			return null;
		}

		return _.find(this.data.events, ({ score }) => {
			if (!score) {
				return false;
			}
			const min = score[0] || DEFAULT_SCORE_LIMIT.MIN;
			const max = Number.isInteger(score[1]) ? score[1] + 1 : Infinity;
			return _.inRange(totalScore, min, max);
		});
	};
}

export { NavigationFacade };
